angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "INTRO_VIDEOS": {
    "VIEW_PROFILE_BTN": "View {name} profile"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/common/intro_videos/intro_videos.json
// module id = 304
// module chunks = 24